<template>
    <div class="header-container">
        <v-navigation-drawer v-model="sidebar" app class="d-lg-none">
            <v-list-item class="flex-column">
                <v-list-item-title class="text-h6 text-left"><img class="header-logo" :src="require('@/assets/Images/ChatFightText.png')"></v-list-item-title>
                <v-list-item-subtitle class="text-left" v-if="display_name">Welcome, {{ display_name }}</v-list-item-subtitle>
            </v-list-item>
            <v-divider></v-divider>
            <v-list>
                <v-list-item
                    v-for="item in navItems"
                    :key="item.name"
                    :to="item.url"
                    link>
                    <v-list-item-title>{{item.name}}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar app :height="100" class="header-bar">
            <template v-slot:prepend>
                <span class="d-lg-none">
                    <v-app-bar-nav-icon @click="sidebar = !sidebar"></v-app-bar-nav-icon>
                </span>
            </template>
            <v-toolbar-title class="app-title" v-if="display_name">
                <img class="header-logo" :src="require('@/assets/Images/ChatFightText.png')">
                Welcome, {{ display_name }}
            </v-toolbar-title>
            <v-toolbar-title class="app-title" v-else>
                <img class="header-logo" :src="require('@/assets/Images/ChatFightText.png')">
            </v-toolbar-title>
            <div class="app-bar-items hidden-xs hidden-sm hidden-md">
                <v-btn
                    flat
                    v-for="item in navItems"
                    :key="item.name"
                    class="pl-6 pr-6"
                    :to="item.url">
                {{ item.name }}
                </v-btn>
                <v-btn
                    v-if="loggedIn"
                    flat
                    @click="logout"
                >Logout</v-btn>
            </div>
            <template v-slot:append>
                <v-app-bar-nav-icon icon style="margin-left: 50px;" @click="toggleMinicart"><v-icon>mdi-cart</v-icon></v-app-bar-nav-icon>
            </template>
        </v-app-bar>
        <v-navigation-drawer 
            v-model="$store.state.cart.minicart_open" 
            app k
            temporary
            location="right" 
            width="300"
            class="cart-drawer">
            <cart-drawer></cart-drawer>
        </v-navigation-drawer>
    </div>
</template>

<script>
import CartComponent from '@/modules/cart/components/CartComponent';
import { deriveNavbarDisplay } from '@/modules/user/displayName';

export default {
    components: {
        CartDrawer: CartComponent
    },
    data() {
        return {
            sidebar: false,
            site_name: 'ChatFight!',
            loggedInNavItems: [
                {
                    name: 'Home',
                    url: '/',
                    icon: 'home'
                },
                {
                    name: 'Equipment',
                    url: '/equipment',
                    icon: 'helmet'
                },
                {
                    name: 'Store',
                    url: '/store',
                    icon: 'store',
                },
                // Account settings entry point (discord-2.3). Visible only
                // when logged in via the navItems computed below, which
                // toggles on this.$store.state.user.loggedIn. Provider-aware
                // username badging lives in 2.7; today the link is plain.
                {
                    name: 'Account',
                    url: '/account-settings',
                    icon: 'account'
                },
                {
                    name: 'About',
                    url: '/about',
                    icon: 'face'
                }
            ],
            loggedOutNavItems: [
                {
                    name: 'Home',
                    url: '/',
                    icon: 'home'
                },
                {
                    name: 'About',
                    url: '/about',
                    icon: 'face'
                },
                {
                    name: 'Login',
                    url: '/login',
                    icon: 'helmet'
                }
            ]
        }
    },
    computed: {
        // 2.7: navbar display follows the session's provider, not a
        // user-overridable name. Derive from the v2 UserMeResponse via
        // deriveNavbarDisplay — which switches on `via_provider`. We do
        // NOT read `state.user.display_name` (that mirror is the server's
        // top-level `display_name`, hardcoded to
        // `providers.twitch.username` and therefore wrong for Discord
        // sessions; see Resolved-at-execution in the 2.7 task file).
        display_name() {
            return deriveNavbarDisplay(this.$store.state.user.me);
        },
        loggedIn() {
            return this.$store.state.user.loggedIn;
        },
        navItems() {
            return this.loggedIn ? this.loggedInNavItems : this.loggedOutNavItems;
        },
        minicart() {
            return this.$store.state.cart.minicart_open;
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        async logout() {
            // 2.7: flip Vuex `me` (and the legacy fields it mirrors) to
            // null first so any reactive consumer sees logged-out state
            // synchronously before the reload. localStorage.clear +
            // reload still drives a full page rebuild; the Vuex dispatch
            // just avoids a one-frame stale render between the click and
            // the reload.
            await this.$store.dispatch('clearMe');
            // Server-side cookie clear. The HttpOnly cf_session cookie is
            // the actual session — JS can't touch it, so the server has to
            // clear it for us. Without this, OAuth pre-guards would treat
            // the next `/auth/twitch` or `/auth/discord` click as
            // "already logged in" and bounce to ?error=link_flow_pending.
            // The catch is non-blocking: if the network call fails (offline,
            // server down), we still clear client state and reload so the
            // user isn't stuck on the page.
            try {
                await fetch('/auth/logout', {
                    method: 'POST',
                    credentials: 'include',
                });
            } catch (err) {
                console.warn('logout: server call failed', err);
            }
            localStorage.clear();
            window.location.reload();
        },
        toggleMinicart() {
            
            this.$store.dispatch('toggleMinicart', this.$store.state.user.twitch_id);
        }
    },
}
</script>

<style>
.header-bar {
    background-color: #000000c0 !important;
    color: white !important;
    justify-content: center;
}
.app-title {
    text-align: left;
    width: 100%;
}
.app-title > div {
    display: flex;
    align-items: center;
}
.header-logo {
    width: 200px;
}
.cart-drawer {
    margin-top: 0 !important;
    top: 0 !important;
    height: 100vh !important;
    z-index: 2000 !important;
    width: 300px !important;
}
.cart-header {
    padding: 32px;
    color: #111;
}
</style>